import React, { useState } from 'react';
import axios from 'axios';

const TestEmailSender = () => {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');

  const handleSend = async () => {
    try {
      const res = await axios.post('http://localhost:5000/api/test-email', {
        to, subject, message
      });
      setResponse(res.data.message);
    } catch (err) {
      console.error(err);
      setResponse('Failed to send email.');
    }
  };

  return (
    <div className="container mt-4">
      <h3> Test Email Sender</h3>
      <div className="mb-3">
        <label>Email To</label>
        <input type="email" className="form-control" value={to} onChange={e => setTo(e.target.value)} />
      </div>
      <div className="mb-3">
        <label>Subject</label>
        <input type="text" className="form-control" value={subject} onChange={e => setSubject(e.target.value)} />
      </div>
      <div className="mb-3">
        <label>Message</label>
        <textarea className="form-control" rows="4" value={message} onChange={e => setMessage(e.target.value)} />
      </div>
      <button className="btn btn-primary" onClick={handleSend}>Send Test Email</button>

      {response && <div className="alert alert-info mt-3">{response}</div>}
    </div>
  );
};

export default TestEmailSender;
